const GET_AZURE_FUNCTIONAL_APP = "GET_AZURE_FUNCTIONAL_APP";
const GET_AZURE_FUNCTIONAL_APP_SUCCESS = "GET_AZURE_FUNCTIONAL_APP_SUCCESS";
const GET_AZURE_FUNCTIONAL_APP_ERROR = "GET_AZURE_FUNCTIONAL_APP_ERROR";

export {
  GET_AZURE_FUNCTIONAL_APP,
  GET_AZURE_FUNCTIONAL_APP_ERROR,
  GET_AZURE_FUNCTIONAL_APP_SUCCESS,
};
